import { Dispatch, SetStateAction, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { templateCreateMultipleCompaniesRoute } from '@features/enterprise/api/constants';
import { errorMessage } from '@features/profile';
import axiosInstance from '@server/axiosInstance';
import { templateList } from '../constants';

type useCreateMultipleCompaniesProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};
type CompaniesVariables = {
  business_name: string;
  name: string;
  email: string;
  phone?: string;
  s_address1: string;
  s_city: string;
  s_lat?: number;
  s_lon?: number;
  s_state: string;
  website?: string;
  s_zip: string;
  timezone?: string;
  user_name: string;
};

export const useCreateMultipleCompanies = ({
  setErrorText = () => {},
}: useCreateMultipleCompaniesProps) => {
  const [response, setResponse] = useState<{ error: string[]; success: string[] }>({
    error: [],
    success: []
  })
  const client = useQueryClient();

  const { mutate: createCompanies, isLoading: isCreatingCompanies} =
    useMutation({
      mutationFn: (variables: {
        companies: CompaniesVariables[];
        etemplate_id: string | number;
      }) =>
        axiosInstance
          .post(templateCreateMultipleCompaniesRoute, variables)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else if (data.status === 200) {
          setErrorText('');
          client.invalidateQueries([templateList]);
          setResponse({
            error: [...data.errors],
            success: [...data.success]
          })
        }
      },
      onError: () => setErrorText(errorMessage),
    });

  return {
    createCompanies,
    isCreatingCompanies,
    response
  };
};
